export function downlaodFile(src: string, fileName: string) {
  const a = document.createElement('a');
  a.href = src;
  a.download = fileName;
  a.click();
}
